export default "__VITE_ASSET__CWCkNUSB__"